import { render } from "./Button.vue?vue&type=template&id=6fe0cbf6&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=6fe0cbf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6fe0cbf6"

export default script